import { useContext } from "react";
import Context from "../context";

const useKeycloakContext = () => {
  return useContext(Context);
};

export default useKeycloakContext;
